<template>
    <div class="margin-header">
        <TopBar :title="$vuetify.lang.t('$vuetify.AttendanceOverview.pageName')" />
        <div class="box-round display-height">
            <div class="box-content px-0">
                <div class="px-7 d-flex pr-8">
                    <div class="flex-auto mr-2">
                        <v-text-field
                            class="custom-input-search search"
                            hide-details="auto"
                            outlined
                            :placeholder="$vuetify.lang.t('$vuetify.AttendanceOverview.search.placeholder')"
                            v-model="textSearch"
                            @input="inputSearch()"
                        ></v-text-field>
                    </div>
                     <div class="width-item">
                        <CustomIconDatePicker v-model="date" @onChangeDate="onChangeDate($event)"/>
                    </div>
                </div>
                <div class="d-flex flex-nowrap text-sm custom-margin mt-5 line-liff-detail">
                    <v-col cols="6" class="px-0 py-0 pl-7 text-blue">
                        {{total}} {{$vuetify.lang.t('$vuetify.AttendanceOverview.people')}}
                    </v-col>
                    <v-col cols="6" class="px-0 py-0 text-right pr-7 text-base-grey2">
                        {{textDate}}
                    </v-col>
                </div>
                <div class="my-3 px-7 text-sm line-liff-header-table">
                    <div class="item-info bg-grey-5 rounded px-4 py-2">
                        <div>
                            <v-row @click="isCollapse = !isCollapse">
                                <v-col cols="8">
                                    {{$vuetify.lang.t('$vuetify.AttendanceOverview.detail.title')}}
                                </v-col>
                                <v-col cols="4" class="text-right">
                                    <v-icon small v-if="isCollapse">fas fa-angle-down</v-icon>
                                    <v-icon small v-else>fas fa-angle-up</v-icon>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="border-top mt-2 pt-2  text-base-grey2 line-liff-detail liff-line-font-size-14" v-if="!isCollapse">
                            <v-row>
                                <v-col cols="8">
                                    {{$vuetify.lang.t('$vuetify.AttendanceOverview.detail.present')}}
                                </v-col>
                                <v-col cols="4" class="text-right">{{summary.present}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="8">
                                    {{$vuetify.lang.t('$vuetify.AttendanceOverview.detail.late')}}
                                </v-col>
                                <v-col cols="4" class="text-right">{{summary.late}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="8">
                                     {{$vuetify.lang.t('$vuetify.AttendanceOverview.detail.halfDay')}}
                                </v-col>
                                <v-col cols="4" class="text-right">{{summary.halfAbsent}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="8">
                                     {{$vuetify.lang.t('$vuetify.AttendanceOverview.detail.absent')}}
                                </v-col>
                                <v-col cols="4" class="text-right">{{summary.absent}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="8">
                                     {{$vuetify.lang.t('$vuetify.AttendanceOverview.detail.leave')}}
                                </v-col>
                                <v-col cols="4" class="text-right">{{summary.leave}}</v-col>
                            </v-row>
                        </div>
                    </div>
                </div>
                <div class="mt-5 d-flex flex-nowrap header-item line-liff-header-table">
                    <v-col cols="7" class="px-0 py-2  pl-7">
                        {{$vuetify.lang.t('$vuetify.AttendanceOverview.header.full')}}
                    </v-col>
                    <v-col cols="3" class="px-0 py-2  pl-4">
                        {{$vuetify.lang.t('$vuetify.AttendanceOverview.header.sub')}}
                    </v-col>
                    <v-col cols="2" class="px-0 py-2"></v-col>
                </div>
                <div class="pb-5">
                  <div class="d-flex flex-nowrap list-item"
                   v-for="(v, i) of list"
                   @click="clickGotoDetail(v.bureauId, v.shortName)"
                   :key="i">
                      <v-col cols="7" class="px-0 py-2 font-weight-bold pl-7 text-truncate">
                        {{ v.name }}
                      </v-col>
                      <v-col cols="3" class="px-0 py-2 font-weight-bold pl-4">
                        {{ v.shortName }}
                      </v-col>
                      <v-col cols="2" class="px-0 py-2 text-center">
                        <v-icon >mdi mdi-chevron-right</v-icon>
                      </v-col>
                  </div>
                </div>
            </div>
            <div class="box-footer">
                <div class="bottom-paging">
                    <v-pagination
                      v-model="page"
                      class="my-0 text-sm"
                      :length="numPages"
                      @input="search()"
                    ></v-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import TopBar from '@/components/Liff/Components/header/TopBar.vue'
import CustomIconDatePicker from '@/components/Liff/Components/Input/CustomIconDatePicker.vue'
export default {
    name: 'AttendanceOverview',
    components: {
        TopBar,
        CustomIconDatePicker
    },
    data: function () {
        return {
            delayTimer: null,
            lineUserId: null,
            lineLiffId: process.env.VUE_APP_LINE_LIFF_HISTORY_ATTENDANCE_OVERVIEW,
            isCollapse: true,
            date: null,
            page: 1,
            total: 0,
            numPages: 1,
            title: null,
            list: [],
            textSearch: null,
            summary: {
                absent: 0,
                halfAbsent: 0,
                late: 0,
                leave: 0,
                present: 0
            }
        }
    },
    computed: {
        textDate: function () {
            const lang = localStorage.getItem('lang')
            const date = this.$dateUtil.formatDate(this.date)
            const [d, m, y] = date.split('/')
            const months = this.$dateUtil.months(lang)
            return `${d} ${months[parseInt(m) - 1]} ${y}`
        }
    },
    created: function () {
        this.date = moment().format('YYYY-MM-DD')
    },
    mounted: function () {
        this.initialData()
    },
    methods: {
        initialData: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)
                this.lineUserId = lineUserId
                await this.search()
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        },
        onChangeDate: function () {
            this.search()
        },
        inputSearch: async function () {
            clearTimeout(this.delayTimer)
            this.delayTimer = setTimeout(this.search, 500)
        },
        search: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const paramsSummary = {
                    lineId: this.lineUserId,
                    date: this.date
                }
                const resSummary = await this.axios.post('attendances/line/hr-president/summary', paramsSummary)
                if (resSummary && resSummary.data && resSummary.data.status === 'ok') {
                    this.summary = resSummary.data.data
                    const { absent, halfAbsent, late, leave, present } = this.summary
                    this.total = absent + halfAbsent + late + leave + present
                }
                const params = {
                    lineId: this.lineUserId,
                    search: this.textSearch,
                    date: this.date,
                    page: this.page
                }
                const res = await this.axios.post('attendances/line/hr-president/data', params)
                if (res && res.data && res.data.status === 'ok') {
                    this.list = res.data.data
                    this.numPages = res.data.numPages
                }
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        },
        clickGotoDetail: function (id) {
            this.$router.push({ name: 'history-attendance-bureau', query: { id } }, () => {})
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@/styles/color.scss';
    .flex-auto {
        flex: 1;
    }
    .header-item {
        color: $base-grey2;
        background: #d9e4ed;
        font-size: 14px;
    }
    .list-item {
        color: $base-grey3;
        &:not(:last-child){
            border-bottom: 1px solid #e0e0e0;
        }
    }
    ::v-deep .v-pagination__item{
        font-family: LexendDeca;
        font-size:12px;
    }
</style>
